// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-datepicker-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 246px;
  height: 40px;
  padding: 0 16px;
  background: #FFFFFF;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  position: relative; /* allow absolute positioning of hidden picker */
}
.custom-datepicker-container:hover {
  border-color: #6366F1;
  background-color: #F9FAFB;
}
.custom-datepicker-container .date-text {
  font-size: 16px;
  font-weight: 500;
  color: #4B5563;
  -webkit-user-select: none;
          user-select: none;
}
.custom-datepicker-container .calendar-icon {
  font-size: 20px;
  color: #6B7280;
  display: flex;
  align-items: center;
  /* Ensure icon is visible */
}
.custom-datepicker-container .calendar-icon::before {
  display: block !important;
}

/* Hidden picker is positioned to cover the visible container so the datepicker overlay anchors correctly */
.hidden-picker {
  position: absolute;
  inset: 0; /* top:0; right:0; bottom:0; left:0 */
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  opacity: 0; /* invisible but present in layout for overlay anchor */
  pointer-events: none; /* prevent mouse events on the hidden inputs */
  z-index: 1;
  /* ensure internal wrappers don't add extra spacing */
}
.hidden-picker ::ng-deep .mat-mdc-text-field-wrapper {
  padding: 0 !important;
  height: 100% !important;
}

/* Ensure the hidden picker doesn't affect layout */
::ng-deep .mat-mdc-form-field.mat-form-field-appearance-outline .mat-mdc-text-field-wrapper {
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/custom-date-range-picker/custom-date-range-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA,EAAA,gDAAA;AACF;AACE;EACE,qBAAA;EACA,yBAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;AAAJ;AAGE;EACE,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EAEA,2BAAA;AAFJ;AAGI;EACE,yBAAA;AADN;;AAMA,2GAAA;AACA;EACE,kBAAA;EACA,QAAA,EAAA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA,EAAA,uDAAA;EACA,oBAAA,EAAA,8CAAA;EACA,UAAA;EAEA,qDAAA;AAJF;AAKE;EACE,qBAAA;EACA,uBAAA;AAHJ;;AAOA,mDAAA;AAGI;EACI,qBAAA;AANR","sourcesContent":[".custom-datepicker-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 246px;\n  height: 40px; \n  padding: 0 16px;\n  background: #FFFFFF;\n  border: 1px solid #D1D5DB;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  box-sizing: border-box;\n  position: relative; /* allow absolute positioning of hidden picker */\n\n  &:hover {\n    border-color: #6366F1;\n    background-color: #F9FAFB;\n  }\n\n  .date-text {\n    font-size: 16px; // Updated to 16px\n    font-weight: 500;\n    color: #4B5563;\n    user-select: none;\n  }\n\n  .calendar-icon {\n    font-size: 20px; // Larger icon for 48px height\n    color: #6B7280;\n    display: flex;\n    align-items: center;\n    \n    /* Ensure icon is visible */\n    &::before {\n      display: block !important;\n    }\n  }\n}\n\n/* Hidden picker is positioned to cover the visible container so the datepicker overlay anchors correctly */\n.hidden-picker {\n  position: absolute;\n  inset: 0; /* top:0; right:0; bottom:0; left:0 */\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  opacity: 0; /* invisible but present in layout for overlay anchor */\n  pointer-events: none; /* prevent mouse events on the hidden inputs */\n  z-index: 1;\n\n  /* ensure internal wrappers don't add extra spacing */\n  ::ng-deep .mat-mdc-text-field-wrapper {\n    padding: 0 !important;\n    height: 100% !important;\n  }\n}\n\n/* Ensure the hidden picker doesn't affect layout */\n::ng-deep .mat-mdc-form-field {\n  &.mat-form-field-appearance-outline {\n    .mat-mdc-text-field-wrapper {\n        padding: 0 !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
